import { ReactNode } from "react";

import { useGlobal } from "../../hooks";

interface Props {
  children: ReactNode;
}

export function Web3Only({ children }: Props) {
  const { mode } = useGlobal();

  return mode === "WEB3" ? <>{children}</> : null;
}
